// extracted by mini-css-extract-plugin
export default {"site":"day_site__eLihL","homeLink":"day_homeLink__zXlIi","fireFly":"day_fireFly__K1hY4","fireFlyLight":"day_fireFlyLight__EV0v0","flash":"day_flash__yluJA"};